import { render, staticRenderFns } from "./aufgaben_verwaltung_router.vue?vue&type=template&id=8dbd9b1a"
import script from "./aufgaben_verwaltung_router.vue?vue&type=script&lang=js"
export * from "./aufgaben_verwaltung_router.vue?vue&type=script&lang=js"
import style0 from "./aufgaben_verwaltung_router.vue?vue&type=style&index=0&id=8dbd9b1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports